import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
`;

export const TextArea = styled.textarea`
  width: 100%;

  border: none;
  outline: 0px none transparent;
  resize: none;

  :focus {
    border: none;
    outline: 0;
  }
`;
